import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  type HttpEvent,
  type HttpInterceptor,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import type { User } from '@app/models';
import { AuthService } from '@app/services/auth.service';
import { SettingsService } from '@app/services/settings.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService, public settingsService: SettingsService,) {}

  intercept(
    request: HttpRequest<User>,
    next: HttpHandler
  ): Observable<HttpEvent<User>> {
    return next.handle(request).pipe(
      catchError((err) => {
        if ([401, 403].includes(err.status)) {
          // auto logout if 401 Unauthorized or 403 Forbidden response returned from api
          // this.authService.logout();
        }
        if (request.url.includes("settings.json")) {
          this.authService.logout();
          this.authService.clearUserAndCredentials().then(() => {
            this.settingsService.clearSettingsData();
          });
        }
        // Handle validation errors (arrays) and other error formats
        let error;
        if (Array.isArray(err.error)) {
          // Backend validation errors are returned as arrays
          error = err.error;
        } else if (err.error?.error) {
          // API error format with error property
          error = err.error.error;
        } else if (err.error?.message) {
          // Standard error message format
          error = err.error.message;
        } else if (err.error && typeof err.error === 'object') {
          // Return the full error object if it exists
          error = err.error;
        } else {
          // Fallback to status text or full error object
          error = err.statusText || err;
        }
        return throwError(error);
      })
    );
  }
}
